class TabbedContentSection extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll(".tab-button");
    this.tabContents = this.querySelectorAll(".tab-content");
    this.initTabs();
  }

  // Initialize tab functionality (exactly like your collection tabs)
  initTabs() {
    this.tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const tabId = button.dataset.tab;
        this.showTab(tabId);
      });
    });
  }

  // Show the selected tab and hide others (same logic as collection tabs)
  showTab(tabId) {
    // Update button states
    this.tabButtons.forEach((button) => {
      button.classList.toggle("active", button.dataset.tab === tabId);
    });

    // Update content visibility
    this.tabContents.forEach((content) => {
      const isActive = content.dataset.tab === tabId;
      content.classList.toggle("active", isActive);
    });
  }
}

// Define the custom element
customElements.define("tabbed-content-section", TabbedContentSection);